// bundle-variant-modal.js
// Handles modal interactions, focus management, and variant selection

window.BundleModalHandler = class BundleModalHandler {
  constructor(bundleManager) {
    this.bundleManager = bundleManager;
    this.modalContainer = document.getElementById('bundle-view-modal-container');
    this.focusableElements = [];
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.lastFocusedElement = null;
  }

  openVariantModal(productHandle, triggerButton = null) {
    const modal = this.modalContainer;
    if (!modal) {
      console.error('Modal container not found');
      if (triggerButton) {
        triggerButton.classList.remove('loading');
        triggerButton.disabled = false;
      }
      return;
    }

    const url = `/products/${productHandle}?view=product-bundle`;
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const bundleContent = html.querySelector('.product-bundle-view');

        if (bundleContent) {
          modal.innerHTML = '';
          modal.appendChild(bundleContent);

          requestAnimationFrame(() => {
            const variantHandler = modal.querySelector('bundle-variant-handler');
            if (variantHandler && typeof variantHandler.init === 'function') {
              variantHandler.init();
            }

            if (variantHandler) {
              variantHandler.attachButtonListener();
            }

            this.setupFocusTrap();
            this.firstFocusable?.focus();

            if (triggerButton) {
              triggerButton.classList.remove('loading');
            }
          });
        }
      })
      .catch(error => {
        console.error('Error loading variant modal:', error);
        modal.innerHTML = `<div class="error">Error: ${error.message}</div>`;

        if (triggerButton) {
          triggerButton.classList.remove('loading');
          triggerButton.disabled = false;
        }
      });
  }

  closeModal() {
    const modal = this.modalContainer;
    if (!modal) return;

    modal.classList.remove('open');
    modal.innerHTML = '';
    document.body.style.overflow = '';

    const allButtons = document.querySelectorAll('.add-to-bundle-variant');
    allButtons.forEach(button => {
      button.classList.remove('loading');
      const productItem = button.closest('.product-card');
      if (productItem && !this.bundleManager.temporaryBundle.has(productItem.dataset.productHandle)) {
        button.disabled = false;
      }
    });

    if (this.lastFocusedElement) {
      requestAnimationFrame(() => {
        this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      });
    }
  }

  setupFocusTrap() {
    if (!this.modalContainer) return;

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    this.focusableElements = Array.from(this.modalContainer.querySelectorAll(focusableSelectors))
      .filter(el => el.offsetParent !== null && !el.hasAttribute('hidden') && el.tabIndex !== -1);

    if (this.focusableElements.length > 0) {
      this.firstFocusable = this.focusableElements[0];
      this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
    }
  }

  handleTabKey(event) {
    if (!this.focusableElements?.length) return;

    if (event.shiftKey && document.activeElement === this.firstFocusable) {
      event.preventDefault();
      this.lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === this.lastFocusable) {
      event.preventDefault();
      this.firstFocusable.focus();
    }
  }

  setupModalEventListeners() {
    document.addEventListener('click', (event) => {
      if (event.target.closest('.bundle-modal-close') ||
        (event.target.id === 'bundle-view-modal-container' && event.target.classList.contains('open'))) {
        this.closeModal();
        return;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!this.modalContainer?.classList.contains('open')) return;

      if (event.key === 'Escape') {
        this.closeModal();
      } else if (event.key === 'Tab') {
        this.handleTabKey(event);
      }
    });
  }

  focusNextAvailableProduct(currentProductItem, productItems) {
    const productItemsArray = Array.from(productItems);
    const currentIndex = productItemsArray.indexOf(currentProductItem);

    for (let i = currentIndex + 1; i < productItemsArray.length; i++) {
      const addButton = productItemsArray[i].querySelector('.add-to-bundle-variant, .product-add-bundle');
      if (addButton && !addButton.disabled && !this.bundleManager.temporaryBundle.has(productItemsArray[i].dataset.productHandle)) {
        this.lastFocusedElement = addButton;
        return;
      }
    }

    for (let i = 0; i < currentIndex; i++) {
      const addButton = productItemsArray[i].querySelector('.add-to-bundle-variant, .product-add-bundle');
      if (addButton && !addButton.disabled && !this.bundleManager.temporaryBundle.has(productItemsArray[i].dataset.productHandle)) {
        this.lastFocusedElement = addButton;
        return;
      }
    }

    this.lastFocusedElement = this.bundleManager.addToCartAllButton?.disabled
      ? currentProductItem.querySelector('.add-to-bundle-variant, .product-add-bundle')
      : this.bundleManager.addToCartAllButton;
  }

  setLastFocusedElement(element) {
    this.lastFocusedElement = element;
  }
};